import { render } from "./AzurePage.vue?vue&type=template&id=7b189070&scoped=true"
import script from "./AzurePage.vue?vue&type=script&lang=js"
export * from "./AzurePage.vue?vue&type=script&lang=js"

import "./AzurePage.vue?vue&type=style&index=0&id=7b189070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b189070"]])

export default __exports__